import { Circle } from '@mui/icons-material';
import { Box, Typography, useMediaQuery, useTheme } from '@mui/material';
import { useIntl } from 'react-intl';
export function CalendarLegend({
  forceSmallView
}: {
  forceSmallView?: boolean;
}) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm')) || forceSmallView;
  const intl = useIntl();
  const availabilityOptions = [{
    color: 'success.main',
    label: intl.formatMessage({
      id: "common.available",
      defaultMessage: [{
        "type": 0,
        "value": "Available"
      }]
    })
  }, {
    color: 'warning.main',
    label: intl.formatMessage({
      id: "common.fewLeft",
      defaultMessage: [{
        "type": 0,
        "value": "Few left"
      }]
    })
  }, {
    color: 'error.main',
    label: intl.formatMessage({
      id: "common.soldOut",
      defaultMessage: [{
        "type": 0,
        "value": "Sold out"
      }]
    })
  }, {
    color: 'action.disabled',
    label: intl.formatMessage({
      id: "common.cancelled",
      defaultMessage: [{
        "type": 0,
        "value": "Cancelled"
      }]
    })
  }];
  return <Box sx={[() => ({
    display: 'flex',
    bottom: '1.5rem',
    pointerEvents: 'none'
  }), isMobile ? {
    justifyContent: 'flex-start'
  } : {
    justifyContent: 'center'
  }, isMobile ? {
    position: 'static'
  } : {
    position: 'sticky'
  }, forceSmallView ? {
    width: '100%'
  } : {
    width: 'auto'
  }]}>
      <Box sx={[theme => ({
      display: 'inline-flex',
      gap: '12px',
      borderRadius: theme.shape.borderRadius,
      background: theme.palette.background.paper
    }), isMobile ? {
      boxShadow: 'none'
    } : {
      boxShadow: theme.shadows[3]
    }, isMobile ? {
      padding: '0'
    } : {
      padding: '12px 20px 12px 16px'
    }]}>
        {availabilityOptions.map(option => <Box key={option.label} sx={{
        display: 'inline-flex',
        alignItems: 'center'
      }}>
            <Circle sx={[{
          color: option.color
        }, isMobile ? {
          height: '5px'
        } : {
          height: '10px'
        }]} />
            <Typography sx={{
          color: 'text.secondary',
          fontSize: '12px',
          lineHeight: '20px',
          letterSpacing: '0.2px'
        }}>
              {option.label}
            </Typography>
          </Box>)}
      </Box>
    </Box>;
}